<template>
<b-form>
<b-row class="m-2">
    <b-col v-if="loaded === false">
         <template>
            <div class="OTloading">
                <div class="OTloader"></div>
            </div>
        </template>
    </b-col>
    <b-col v-else>
        <b-row>
            <ECMErrorDialog ref="messageDlg" v-model="messageDlg"/>          
            <ECMExcludedFolderModal v-model="showECMExcludedFolderModal" :existingNames="paramSets" ref="ecmExcludedFolderModal" /> 
            <ECMConfirmDialog ref="confirmationDlg" v-model="confirmationDlg"/>
        </b-row>
    </b-col>
</b-row>
<b-row class="row no-gutters">
            <b-col class="col-auto col">
                <b-nav>
                    <b-nav-item v-for="action in globalActions" @click.prevent="onGlobalAction(action)" >
                        <otif-icon :icon="action.name" :label="action.label" :title="action.label" key="action.name"/>
                    </b-nav-item>
                </b-nav>
            </b-col>
            
        </b-row>
        <b-row  >
            <b-col v-if="paramSets.length === 0">
                <span class="OTtableJobType"><p> {{ecmResourceStrings.txtFoldersNotDefined}}</p>
                    <otif-icon icon="information"/>
                </span >
            </b-col>
             <b-col v-else>
                <ecmconnection-select
                    v-model="$v.selectedSet"
                    v-bind:label="ecmResourceStrings.lblECMFolders"
                    :parameters="paramSets"
                    :selectedSet="selectedSet"
                    ref="params_selector"
                    :description="ecmResourceStrings.tipECMFolders"
                    v-bind:invalidMessage="ecmResourceStrings.msgECMFolderRequired"
                    @reselected="reselected"/>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <template v-if="loaded === false">
                    <div class="OTloading">
                        <div class="OTloader"></div>
                    </div>
                </template>
                <template v-else-if="loaded === true && paramSets.length === 0">
                   
                </template>
               <SettingsTable v-else
                    :rows="selectedParameters"
                    :columns="columns"
                    :customOptions="customOptions"
                    :formcolumn="'3'"
                    @save="save">
                    <template slot="table-header">
                        <h1 class="text-center OT-table-title">
                          {{selectedName}}
                        </h1>
                    </template>
                </SettingsTable>
            </b-col>
        </b-row>
        </b-form>
</template>

<script>

import ECMErrorDialog from '../../modals/ECMCrawlerMessageDlg.vue';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { numericval } from '../../../utils/validatorECM.js';
import { showMessage } from '../../../utils/commonECM.js';
import OtifGlobalActions from '../../../../../../mtm-studio-components/src/components/table/GlobalActions.vue';
import SettingsTable from '@/ecm/components/ECMParametersTable.vue';
import EcmRepositoryConnections from '../../../../ecm/components/widgets/ECMRepositoryConnections.vue';
import ECMExcludedFolderModal from '../../modals/ECMCreateFolder.vue';
import ECMConfirmDialog from '../../modals/ECMCrawlerConfirmDlg.vue';
import { showConfirmationDialog } from '../../../utils/commonECM.js';
import StatusColumn from '../../links/ecmmandatorystatus.vue';

export default {

    props: ['ecmRepository', 'parametersFromGrammar', 'realFoldersConfigurations' , 'availableFoldersConfigurations'],
    
    components: {
        ECMErrorDialog,
        OtifGlobalActions,
        SettingsTable,
        ECMExcludedFolderModal,
        'ecmconnection-select': EcmRepositoryConnections,
        ECMConfirmDialog,
    },
    mixins: [ validationMixin ],

    watch: {
        
    },

    data() {
        return { 
            paramSets : [],//set of folders
            selectedSet:'0',
            selectedName:'',
            selectedParameters:[],
            fullPackage : [],
            
            lastexistingindex:-1,// see note
       
            loaded: false,
            messageDlg: false,
            confirmationDlg:false,
            showECMExcludedFolderModal: false,
            ecmResourceStrings: require('../../../utils/resourceECM.js'),   
            
            customOptions:  [],
            globalActions: [{
                    name: 'add',
                    label: 'Add Excluded Folder',
                    callback: () => { this.addExcludedFolder(); }
                },
                {
                    name: 'delete',
                    label: 'Delete Excluded Folder',
                    callback: () => { this.deleteExcludedFolder(); }
            }],
            columns:[{
                name: 'name',
                label: 'Name',
                sortable: false,
                editable:false,
                render(row) {
                    return row.name;
                }
            },{
                name: 'type',
                label: 'Type',
                sortable: false,
                editable:false,
                render(row) {
                    return row.type;
                }
            },{
                name: 'status',
                label: '',
                sortable: false,
                editable:false,
                displayComponent:StatusColumn,
                
            },{
                name: 'value',
                label: 'Value',
                sortable: false,
                editable:true,
                render(row) {
                    return row.value;
                }
            }],
        }
    },

    validations: {
        form: {
         
        }
    },

    computed: {
        
    },

    methods: {
        
        onGlobalAction(action) {
            if (action['callback']) {
                action.callback(action);
            }
        },

        addExcludedFolder(){
            this.showECMExcludedFolderModal = true;
        },

        createEcmExcludedFolder(conDescr){
            var that = this;
                        
            const len = that.paramSets.length;
            
            that.lastexistingindex++;
            
            var OneSet = [];
            
            for (var cnt = 0; cnt < that.fullPackage.length; cnt++)
            {
                const name  = that.fullPackage[cnt].name;
                
                if(name == 'folderPathOrId')
                {
                    that.realFoldersConfigurations.push({"name" : that.fullPackage[cnt].name, "type" : that.fullPackage[cnt].type, "defaultvalue": that.fullPackage[cnt].defaultvalue, "mandatory" : that.fullPackage[cnt].mandatory, "value": conDescr, "index": that.lastexistingindex});
                    OneSet.unshift({"name" : name, "type" : that.fullPackage[cnt].type, "defaultvalue": that.fullPackage[cnt].defaultvalue, "mandatory" : 1, "value": conDescr, "index": that.lastexistingindex });
                }
                else
                {
                    that.realFoldersConfigurations.push({"name" : that.fullPackage[cnt].name, "type" : that.fullPackage[cnt].type, "defaultvalue": that.fullPackage[cnt].defaultvalue, "mandatory" : that.fullPackage[cnt].mandatory, "value": that.fullPackage[cnt].value, "index": that.lastexistingindex});
                    OneSet.push({"name" : name, "type" : that.fullPackage[cnt].type, "defaultvalue": that.fullPackage[cnt].defaultvalue, "mandatory" : that.fullPackage[cnt].mandatory, "value": that.fullPackage[cnt].value, "index": that.lastexistingindex });
                }
            }
                        
            that.paramSets.push({"description":conDescr, "index":that.lastexistingindex, "setOfParameters":OneSet});
            
            if(that.paramSets.length > 0)
            {
                that.selectedSet=that.lastexistingindex;
                var cnt = 0;
                for (cnt = 0; cnt < that.paramSets.length; cnt++)
                {
                    if(that.paramSets[cnt].index == that.lastexistingindex)
                    {
                        that.selectedName=that.paramSets[cnt].description;    
                        that.selectedParameters = that.paramSets[cnt].setOfParameters;
                        break;
                    }
                }
                if(that.$refs.params_selector)
                    that.$refs.params_selector.refresh();
            }
        },

        deleteExcludedFolder(){
            var that = this;
            showConfirmationDialog(that, 'question', that.ecmResourceStrings.ttlDeleteFolder, that.ecmResourceStrings.txtDeleteFolder);
         },
        
        saveConfirmed()
        {         
            this.confirmationDlg = false;
            var that = this;
            const itemX=that.selectedSet;
            var cnt = 0;
            for (cnt = 0; cnt < that.paramSets.length; cnt++)
            {
                if(that.paramSets[cnt].index == itemX)
                {
                    const removed = that.paramSets.splice(cnt, 1);
                    break;
                }
            }

            if(that.paramSets.length > 0)
            {
                that.selectedSet=that.paramSets[0].index;
                that.selectedName=that.paramSets[0].description;
                that.selectedParameters = that.paramSets[0].setOfParameters;
                if(that.$refs.params_selector)
                    that.$refs.params_selector.refresh();  
            }
            else{
                that.selectedSet=0;
                that.selectedName='';
                that.selectedParameters=[];
            }
           
            //remove from real parameters
            cnt = 0;   
            for (cnt = that.realFoldersConfigurations.length -1; cnt > -1; cnt--)
            {
                const index = that.realFoldersConfigurations[cnt].index;
                if(index == itemX)   
                {
                    const removed = that.realFoldersConfigurations.splice(cnt, 1);
                }
            }
        },

        reselected(value) {
           var that = this;
           that.selectedSet=value;
           var cnt = 0;
           for (cnt = 0; cnt < that.paramSets.length; cnt++)
            {
                if(that.paramSets[cnt].index == value)
                {
                    that.selectedName=that.paramSets[cnt].description;    
                    that.selectedParameters = that.paramSets[cnt].setOfParameters;
                    return;
                }
            }
        },

        save(element) {
            //prevent old name just in case if for mandatory field value is empty 
            var that = this;
            var originalvalue='';
            var result = this.realFoldersConfigurations.filter((el) => (el.name == element.name && el.index == element.index));
            
            if (result == undefined || result.length == 0)
            {
                //not found
            }
            else if (result.length == 1)
            {
                originalvalue = result[0].value;
            }

            const value = element.value;
            var configvalue = "";
            if(value.trim().length > 0)
            {
                configvalue = JSON.stringify(value); 
                //configvalue = configvalue.replace(/"/g, ""); 
                configvalue = configvalue.replace(/"/ , ""); 
                configvalue = configvalue.replace(/"$/,"");
            }
            else if(element.mandatory == 1/* && element.name == 'description'*/)
            {
                //can not be empty
                this.$snotify.clear();
                this.$snotify.error(this.ecmResourceStrings.txtErrorMandatory);
                element.value = originalvalue;
                return;
            }
            if (result[0])
            {
                //should be here
                result[0].value = element.value;
                //change description of package in set
                if(element.name == 'folderPathOrId')
                {
                    var cnt = 0;
                    for (cnt = 0; cnt < that.paramSets.length; cnt++)
                    {
                        if(that.paramSets[cnt].description == originalvalue)
                        {
                            that.paramSets[cnt].description = element.value; 
                            that.selectedName=that.paramSets[cnt].description;  
                            if(that.$refs.params_selector)
                                that.$refs.params_selector.refresh();

                            break;
                        }
                    }
                }
            }
        },

        initParams : function()
        {   
            var that = this;
            that.fullPackage = [];//all mandatory + available together - one whole set (prototype of set) 
            that.paramSets = [];
            for (var cnt = 0; cnt < that.availableFoldersConfigurations.length; cnt++)
            {
                that.fullPackage.push({"name" : that.availableFoldersConfigurations[cnt].name, "type" : that.availableFoldersConfigurations[cnt].type, "defaultvalue": that.availableFoldersConfigurations[cnt].defaultvalue, "mandatory" : that.availableFoldersConfigurations[cnt].mandatory, "value": that.availableFoldersConfigurations[cnt].value});
            }
            var startindex = -1;
            var lastindex = -1;
            var OneSet = [];
            var descr = '';
            var index = -1;
            for (var cnt = 0; cnt < that.realFoldersConfigurations.length; cnt++)
            {
                const name = that.realFoldersConfigurations[cnt].name;
                if(startindex == -1)
                {
                    startindex = 0;
                }
                lastindex = that.realFoldersConfigurations[cnt].index;
                if(that.realFoldersConfigurations[cnt].index == startindex)
                {
                    if(name == 'folderPathOrId')
                    {
                        descr = that.realFoldersConfigurations[cnt].value;
                        index = that.realFoldersConfigurations[cnt].index;
                        OneSet.unshift({"name" : that.realFoldersConfigurations[cnt].name, "type" : that.realFoldersConfigurations[cnt].type, "defaultvalue": that.realFoldersConfigurations[cnt].defaultvalue, "mandatory" : 1, "value": that.realFoldersConfigurations[cnt].value, "index": that.realFoldersConfigurations[cnt].index});
                    }
                    else
                    {
                        OneSet.push({"name" : that.realFoldersConfigurations[cnt].name, "type" : that.realFoldersConfigurations[cnt].type, "defaultvalue": that.realFoldersConfigurations[cnt].defaultvalue, "mandatory" : that.realFoldersConfigurations[cnt].mandatory, "value": that.realFoldersConfigurations[cnt].value, "index": that.realFoldersConfigurations[cnt].index});
                    }
                }
                else
                {
                    //index was changed

                    that.paramSets.push({"description":descr, "index":index, "setOfParameters":OneSet});
                    startindex = that.realFoldersConfigurations[cnt].index;
                    OneSet = [];
                    if(name == 'folderPathOrId')
                    {
                        descr = that.realFoldersConfigurations[cnt].value;
                        index = that.realFoldersConfigurations[cnt].index;
                        OneSet.unshift({"name" : that.realFoldersConfigurations[cnt].name, "type" : that.realFoldersConfigurations[cnt].type, "defaultvalue": that.realFoldersConfigurations[cnt].defaultvalue, "mandatory" : 1, "value": that.realFoldersConfigurations[cnt].value, "index": that.realFoldersConfigurations[cnt].index});
                    }
                    else
                    {
                        OneSet.push({"name" : that.realFoldersConfigurations[cnt].name, "type" : that.realFoldersConfigurations[cnt].type, "defaultvalue": that.realFoldersConfigurations[cnt].defaultvalue, "mandatory" : that.realFoldersConfigurations[cnt].mandatory, "value": that.realFoldersConfigurations[cnt].value, "index": that.realFoldersConfigurations[cnt].index});
                    } 
                }
            }
            
            if(lastindex != -1 && lastindex == startindex) //the last one
            {
                 that.paramSets.push({"description":descr, "index":index, "setOfParameters":OneSet});
            }
            if(that.paramSets.length > 0)
            {
                that.selectedSet=0;
                that.selectedName=that.paramSets[0].description;
                that.selectedParameters = that.paramSets[0].setOfParameters;
            }
            that.lastexistingindex = lastindex;
        },
        
    },
  
    mounted() {

            var breadcrumbs = [{
                name: 'settings',
                meta: { label: 'Settings' }
            },        {
                name: 'ecm-repositories',
                meta: { label: 'Repositories' }
            },{
                name: 'ecm-repo',
                meta: { label: 'Update ECM Repository' }
            }];
            this.$store.commit('breadcrumbs', breadcrumbs);
    },

    created() {
        var that = this;
        that.initParams();
        that.loaded = true;
    },
}
</script>